// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const regieleki: PokeData = {
  "id": 894,
  "name": "regieleki",
  "height": 12,
  "weight": 1450,
  "base_experience": 290,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "thrash",
    "hyper-beam",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "explosion",
    "zap-cannon",
    "lock-on",
    "rapid-spin",
    "extreme-speed",
    "ancient-power",
    "shock-wave",
    "magnet-rise",
    "electroweb",
    "thunder-cage"
  ],
  "moves": [
    "thunder-shock",
    "thunderbolt",
    "zap-cannon",
    "ancient-power",
    "thunder-punch",
    "wild-charge",
    "quick-tempo",
    "thunder-fang",
    "electric-wrath",
    "volt-switch",
    "volt-crash",
    "thunder",
    "electric-terrain"
  ],
  "evolution_chain": {
    "id": 472,
    "item": null,
    "species": [
      {
        "name": "regieleki",
        "order": 894,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 71,
    "speed": 219,
    "ability_power": 110
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
